import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from '../../shared/ErrorPage';
import { AuthProvider } from './lib/auth';
import { LayoutProvider } from './lib/layout';
import { ThemeProvider } from './lib/theme';
import { ToastProvider } from './components/ui';
import './styles/theme.css';
import './styles/app.css';
import './styles/glass.css';
import './styles/dashboard.css';

/**
 * Grundpfad für den Router.
 *
 * Stammt aus derselben Quelle wie die API-Pfade (`import.meta.env.BASE_URL`).
 * React Router erwartet ihn ohne abschließenden Schrägstrich; die Wurzel
 * bleibt „/“. Ohne diesen Wert träfe unter einem Unterpfad keine Route –
 * der Router verglichte „/facilityflow/tasks“ mit „/tasks“.
 */
function routerBase(): string {
  const base = import.meta.env.BASE_URL || '/';
  return base === '/' ? '/' : base.replace(/\/$/, '');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
    <ThemeProvider>
      <LayoutProvider>
        <ToastProvider>
          <BrowserRouter basename={routerBase()}>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </ToastProvider>
      </LayoutProvider>
    </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
